import { render, staticRenderFns } from "./BoxContent3.vue?vue&type=template&id=06f0da3e&scoped=true"
import script from "./BoxContent3.vue?vue&type=script&lang=js"
export * from "./BoxContent3.vue?vue&type=script&lang=js"
import style0 from "./BoxContent3.vue?vue&type=style&index=0&id=06f0da3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f0da3e",
  null
  
)

export default component.exports